import api from '../../baseApi';
import {isDebugging} from '../../../utility';
import {AxiosResponse} from 'axios';

export type Request = {
  userID: number;
  email : string;
  firstName: string;
  lastName: string;
  title: string;
};

type Response = {
  status: 'SUCCESS' | 'FAILURE';
  message: string;
};

const addSubAccountPort = '/addSubAccount';

const addSubAccountAPI = async (subAccount: Request): Promise<AxiosResponse<Response>> => {
  const res = await api.post(addSubAccountPort, subAccount);

  if (isDebugging) {
    console.log(`${addSubAccountPort} response:`, res);//TESTING
  }

  return res;
};

export default addSubAccountAPI;